// Currently handles simple values and arrays
//
// const params = {
//   include: 'add_on_category',
//   only_widget_visible: 1,
//   category_ids: [58, 60],
// }
//
// const url = `${this.host}/api/v1/add_ons?${encodeParamsForRails(params)}`

function encodeParamsForRails(params) {
  const queryString = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => queryString.append(`${key}[]`, item))
    } else {
      queryString.append(key, value)
    }
  })

  return queryString.toString()
}

export default encodeParamsForRails
